exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-cart-items tr:last-child td:first-child{border-bottom-left-radius:6.79px}.table-cart-items tr:last-child td:last-child{border-bottom-right-radius:6.79px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d39b904","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/assets/js/store/components/TableItems.vue
// module id = BE9u
// module chunks = 102